module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAAEhyb7BAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAP1JREFUeNpiPOhxO4CBgWE9EH9guH5B7j+QAaaZQCIwAYAAYgQqgzBgIiBpMAAIILgUMoAr0zR4BGcDBBCGSiac2nCqwBAACCCs1hM0FwgagbgeWYAFWRLo7gYouwEWIlhNQvYgDAAEEMhN74G0AB4nBTIRUAAC65kYiABE+Q7DJCQfYioC+QqEYWyoiajhhC2OcVqHDWAowuKRDwABhi8wE+13qC5AFgCqLQBS/VjUfkBPKRiacQF0Q7GFN1mAYCBBg16QYoOghn0gpIYFi1gjtpQCSxzAoABFTAF6ciMYRkgG/CfVRehppoEY74MMcoSWdLjyXT0BM0DhFwgAI4t2RI+hJ0AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/icon/yaoqing.png
// module id = D7Kr
// module chunks = 1